import {
    validatePassword,
    validateFullName,
    validateEmail,
} from '../signup/utils';

export { validatePassword, validateFullName, validateEmail };

export const ACTIVE_CLIENTS_OPTIONS = [
    { value: '0', label: '0 clients' },
    { value: '1-5', label: '1-5 clients' },
    { value: '6-20', label: '6-20 clients' },
    { value: '21-50', label: '21-50 clients' },
    { value: '51+', label: '51+ clients' },
];

export const AGENCY_ERROR_CODES = {
    ERROR_EMAIL_IN_BLACK_LIST: 'ERROR_EMAIL_IN_BLACK_LIST',
    ERROR_REJECTED_EMAIL: 'ERROR_REJECTED_EMAIL',
    ERROR_RECAPTCHA_VALIDATION_FAILED: 'ERROR_RECAPTCHA_VALIDATION_FAILED',
};

export function validateAgencyName(agencyName) {
    if (!agencyName || !agencyName.trim()) {
        return 'Agency name is required';
    }
    return null;
}

export function isValidAgencyForm(validations) {
    return Object.values(validations).every(v => !v);
}
